var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('van-popup',{attrs:{"position":"bottom"},on:{"click":_vm.onCancel},model:{value:(_vm.showPicker),callback:function ($$v) {_vm.showPicker=$$v},expression:"showPicker"}},[_c('van-picker',{attrs:{"show-toolbar":"","columns":_vm.columns,"loading":_vm.loading},on:{"cancel":_vm.onCancel,"confirm":_vm.onConfirm}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }